import { PopupContentDto } from 'enrollment/features/ToDoList/types';
import { PlanContentFile } from '../PlanContentFile';
import './PlanPopupContent.css';

interface PlanPopupContentProps {
  popupContent?: PopupContentDto;
  apiHost: string;
}

export const PlanPopupContent = ({
  popupContent,
  apiHost,
}: PlanPopupContentProps) => {
  const popupContents = popupContent?.plan_popup_contents || [];
  const popupFiles = popupContent?.plan_popup_files || [];
  const planCarrierFiles = popupContent?.carrier_files || [];
  const planContentFiles = popupContent?.files || [];

  return (
    <div id="planPopupContent">
      <h3>You have an important notice you must read:</h3>
      <div>
        {popupContents.map((content: string) => (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        ))}
      </div>
      {popupFiles.length + planContentFiles.length + planCarrierFiles.length >
        0 && (
        <div>
          <h3>Please download the following documents:</h3>
          <div>
            {popupFiles.map((file) => (
              <PlanContentFile file={file} apiHost={apiHost} />
            ))}
            {planCarrierFiles.map((file) => (
              <PlanContentFile file={file} apiHost={apiHost} />
            ))}
            {planContentFiles.map((file) => (
              <PlanContentFile file={file} apiHost={apiHost} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
